import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useResolvedPath,
  useMatch,
  NavLink,
  useLocation,
  matchPath,
  useNavigate,
} from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { masterActions } from "../../_store/master.slice.js";
import { registeredUserActions } from "../../_store/registeredUser.slice.js";
import {
  facilityAction,
  managementUserAction,
  messagesAction,
  revenueReportingActions,
  documentsActions,
  publicUserActions,
  authActions,
  photoAction,
  postalMailActions,
  keywordAction,
  inmateAction,
  kiosksActions,
  staffRequestAction,
  dndAction,
  connectionRequestActions,
  reportingAction,
  IpActivityAction,
  noticeAction,
  eCardAction,
} from "../../_store";
import { PODAction } from "../../_store/pod.slice.js";
// import menus from "./../../config/app-menu.jsx"; // No need for static menus import
import Swal from "sweetalert2";
import Customizesidebar from "./customize-sidebar.jsx";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";

// NavItem Component
const NavItem = React.memo(({ menu, ...props }) => {
  // Ensure menu and menu.URLPath exist before proceeding
  const dispatch = useDispatch();
  const pageReload = useSelector((x) => x?.master?.isPageReload);
  let resolved = useResolvedPath(menu?.URLPath);
  let match = useMatch({ path: resolved?.pathname });
  const authUser = useSelector((x) => x.auth.user);
  const commonFacilityCode = useSelector((x) => x.auth.commonFacilityCode);
  const navigate = useNavigate();
  const location = useLocation();
  const inmateMessageCount =
    parseInt(getStoredValue("inmateMessageCount")) || 0;

  const context = useContext(AppSettings);

  let match2 = menu?.URLPath
    ? matchPath({ path: menu?.URLPath, end: false }, location?.pathname)
    : null;

  if (!menu) {
    return null;
  }

  let icon = menu.CssClassName && (
    <div className="menu-icon">
      <i className={menu.CssClassName}></i>
    </div>
  );
  let img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  let caret = menu.children && !menu.badge && (
    <div className="menu-caret"></div>
  );
  let label = menu.label && (
    <span className="menu-label ms-5px">{menu.label}</span>
  );
  let badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  let highlight = menu.highlight && (
    <i className="fa fa-paper-plane text-theme"></i>
  );
  let MenuName = menu.MenuName && (
    <div className="menu-text">{menu.MenuName}</div>
  );

  // let MenuBadge = menu.MenuName && (
  //   <div className="menu-badge button-success">{menu.NotificationCount}</div>
  // );

  let MenuBadge = menu.MenuName && (
    // <div className="menu-badge button-success" >
    <div className="menu-badge" style={{ backgroundColor: "#FFC506", color: "black", fontWeight: 'bold' }}>
      {menu.NotificationCount +
        (menu.ManagementMenuID === 9 ? inmateMessageCount || 0 : 0)}
    </div>
  );

  const handlePageLoading = (e, path) => {
    Swal.close();
    if (path !== "") {
      navigate(path);
      context.toggleAppSidebarMobile(e);
      const pageReloading = pageReload + 1;
      dispatch(masterActions?.updateLocation(pageReloading));
    }
    const loggedUser = getStoredValue("user");
    dispatch(authActions?.updateUser(loggedUser));

    switch (menu?.URLPath || path) {
      case "/Admin/RegisteredUserList":
        dispatch(registeredUserActions.resetForm());
        dispatch(registeredUserActions.clearRegisteredPublicUserList());
        break;

      case "/Admin/Reporting":
        dispatch(reportingAction.resetTabActive());
        dispatch(reportingAction.resetreqActivityDataSearch());
        dispatch(reportingAction.resetuserActivityDataSearch());
        break;

      case "/Admin/FacilityList":
        dispatch(facilityAction.resetFacilitySearch());
        break;

      case "/Admin/ManagementUserList":
        dispatch(managementUserAction.resetManagementUserSearchData());
        break;

      case "/Admin/RevenueReport":
        dispatch(revenueReportingActions.resetRevenueReports());
        break;

      case "/Admin/MessageList":
        dispatch(messagesAction.resetMessageSearchData());
        break;

      case "/Admin/PostalMailList":
        dispatch(postalMailActions.clearPostalMail());
        dispatch(postalMailActions.clearSearchPostalMail());
        break;

      case "/Admin/DocumentList":
        dispatch(documentsActions.clearDocuments());
        break;

      case "/Admin/PublicUserList":
        dispatch(publicUserActions.clearpublicUserListSearch());
        break;

      case "/Admin/PhotoList":
        dispatch(photoAction?.resetPhotoState());
        break;

      case "/Admin/KeywordList":
        dispatch(keywordAction.clearSearchKeyword());
        dispatch(keywordAction.resetkeyword());
        break;

      case "/Admin/InmateList":
        dispatch(inmateAction.resetInmateSearchData());
        break;

      case "/Admin/PODList":
        dispatch(PODAction?.resetForm());
        dispatch(PODAction.resetSearchPOD());
        break;

      case "/Admin/StaffRequestList":
        dispatch(staffRequestAction?.resetStaffRequestSearcList());
        dispatch(staffRequestAction?.resetPublicDefenderSearchList());
        dispatch(staffRequestAction?.resetMessageToInmateSearchList());
        dispatch(staffRequestAction?.resetPrivateConversationSearchList());
        break;

      case "/Admin/DNDUserList":
        dispatch(dndAction?.clearDNDSearch());
        break;

      case "/Admin/ConnectionRequestList":
        dispatch(connectionRequestActions?.resetConnectionReqSearchData());
        break;

      case "/Admin/IPActivityList":
        dispatch(IpActivityAction?.resetIPSearch());
        break;

      case "/Admin/KioskList":
        let data = {
          podID: 0,
          kioskCode: "",
          maintenanceStatus: 2,
          activeStatus: 2,
          facilityID: commonFacilityCode,
          pageNo: 1,
          rowCountPerPage: 10,
        };
        dispatch(inmateAction.resetInmateSearchData());
        dispatch(kiosksActions?.setKiosksSearch(data));
        break;

      case "/Admin/NoticeList":
        dispatch(noticeAction.resetNoticeSearch());
        break;

      case "/Admin/ECards":
        dispatch(eCardAction.clearECardUploadSearch());
        break;

      case "/Admin/ECard/Category":
        dispatch(eCardAction.clearEcardCategorySearch());
        break;

      case "/Admin/Ecards/sent":
        dispatch(
          eCardAction.updateSentEcardSearch({
            FacilityID: commonFacilityCode,
            InmateResidentId: "",
            PublicFirstName: "",
            PublicLastName: "",
            InmateFirstName: "",
            InmateLastName: "",
            EcardSubject: "",
            EcardSendStartDate: "",
            EcardSendEndDate: "",
            EcardReadStatus: 2,
            PageNo: 1,
            RowCountPerPage: 10,
            SortBy: "Sentdate DESC",
          })
        );
        break;

      default:
        break;
    }

    const Userdetails = getStoredValue("user");
    const ManagementUserID =
      authUser?.ManagementUserID ?? Userdetails?.ManagementUserID ?? 0;
    const facilityCode =
      parseInt(getStoredValue("commonFacilityCode"), 10) ||
      commonFacilityCode?.FacilityID ||
      0;

    if (Userdetails?.UserRoleID === 10 || Userdetails?.UserRoleID === 11) {
      dispatch(
        masterActions.GetPublicDefenderNotificationAlert({
          ManagementUserID: ManagementUserID,
          FacilityID: facilityCode,
        })
      ).then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      });

      dispatch(
        staffRequestAction?.getInmateMessageCount({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      );
    } else {
      dispatch(
        masterActions.GetLoadNotificationAlert({
          ManagementUserID: ManagementUserID,
          FacilityID: facilityCode,
        })
      ).then((response) => {
        const updatedMenuList =
          getStoredValue("menu_list") || response?.payload;

        if (updatedMenuList) {
          dispatch(authActions.updateMenuList(updatedMenuList));
        }
      });

      dispatch(
        staffRequestAction?.getInmateMessageCount({
          FacilityCode: facilityCode,
          ManagementUserID: ManagementUserID,
        })
      );
    }
  };

  // No expand and collapse
  //   const OrginalPathMenuId = menu?.URLPath === location.pathname ? menu?.ManagementMenuID  : null;

  // const submenuPathMenuId = menu?.SubMenus?.find(x => x?.Subpath === location.pathname)?.MenuID || null;

  //  const isChildActive =  (menu?.ManagementMenuID == OrginalPathMenuId) || (menu?.ManagementMenuID == submenuPathMenuId);

  const isChildActive =
    location.pathname.startsWith(menu?.URLPath) && !menu?.children;

  const isparentActive = menu?.children?.some((child) =>
    location.pathname.startsWith(child?.URLPath)
  );

  return (
    <div
      className={
        "menu-item" +
        (isChildActive ? " active" : "") +
        (menu.children ? " has-sub" : "")
      }
    >
      <NavLink
        id={menu?.ManagementMenuID}
        className={`menu-link fs-5 menu-link-custom-style ${isparentActive ? "highlightmenu" : ""
          }`}
        to={menu.URLPath}
        {...props}
        onClick={(e) => {
          handlePageLoading(e, menu.URLPath);
        }}
      >
        {img} {icon} {MenuName}
        {(menu.MenuName === "Staff Requests" && menu.ManagementMenuID === 9
          ? menu.NotificationCount + (inmateMessageCount || 0) > 0
          : menu.NotificationCount > 0) && MenuBadge}
        {caret} {badge}
      </NavLink>

      {menu?.children && (
        <div
          className={"menu-submenu"}
          style={{ display: isparentActive ? "block" : "none" }}
        >
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
});

// SidebarNav Component
function SidebarNav() {
  const context = useContext(AppSettings);
  const menu_list = useSelector((x) => x?.auth?.menu_list);
  const filteredMenus = React.useMemo(() => menu_list, [menu_list]);
  const [filtersidemenu, setfiltersidemenu] = useState(filteredMenus);
  const menuList = getStoredValue("filter_menu_list") || [];

  const processMenu = useCallback(() => {
    const apiResponse = filteredMenus || [];



    const ECardChildren = apiResponse?.filter((item) =>
      [38, 39, 40].includes(item.ManagementMenuID)
    );


    const createMenu = (children, id, name, icon, defaultUrl) => ({
      ManagementMenuID: children.length > 0 ? children[0].ManagementMenuID : id,
      MenuName: name,
      IsSubMenu: 0,
      MenuOrderNo: 1,
      URLPath: "",
      CssClassName: icon,
      MenuActiveStatus: 0,
      NotificationCount: 0,
      children,
    });


    const ECardMenu = createMenu(
      ECardChildren,
      38,
      "Manage E-Cards",
      "fa-solid fa-gift",
      ""
    );

    const filteredMenu = apiResponse.filter(
      (item) =>
        ![
          38, 39, 40,
        ].includes(item.ManagementMenuID)
    );


    return [
      ... (filteredMenu),
      // ...(ECardChildren.length > 0 ? [ECardMenu] : []),
      ...(ECardChildren.length <= 1 ? ECardChildren : [ECardMenu]),
    ];
  }, [filteredMenus]);

  useEffect(() => {
    const list = processMenu();
    setfiltersidemenu(list);
    setStoredValue("filter_menu_list", list);
  }, [processMenu]);

  return (
    <div className="menu inmate-menu-list">
      {menuList?.map((menu, i) => (
        <React.Fragment key={i}>
          {/* Old Menu  */}
          {/* {menu?.ManagementMenuID !== 1000 && <NavItem key={i} menu={menu} />} */}

          {/* Customizes New Menu */}
          {menu?.ManagementMenuID !== 1000 && <Customizesidebar item={menu} />}
        </React.Fragment>
      ))}
    </div>
  );
}


// BackUp SideMenu 
// function SidebarNav() {
//   const context = useContext(AppSettings);
//   const menu_list = useSelector((x) => x?.auth?.menu_list);
//   const filteredMenus = React.useMemo(() => menu_list, [menu_list]);
//   const [filtersidemenu, setfiltersidemenu] = useState(filteredMenus);
//   const menuList = JSON.parse(localStorage.getItem("filter_menu_list")) || [];

//   const processMenu = useCallback(() => {
//     const apiResponse = filteredMenus || [];

//     const order = [14, 5, 6, 7, 3];

//     const userMenuChildren = apiResponse?.filter((item) =>
//       [8, 15, 26, 28].includes(item.ManagementMenuID)
//     );
//     const CommunicationMenuChildren = apiResponse
//       ?.filter((item) => [9, 10].includes(item.ManagementMenuID))
//       .sort((a, b) => a.MenuName.localeCompare(b.MenuName));

//     const FacilityChildren = apiResponse
//       ?.filter((item) => order.includes(item.ManagementMenuID))
//       .sort(
//         (a, b) =>
//           order.indexOf(a.ManagementMenuID) - order.indexOf(b.ManagementMenuID)
//       );

//     const ECardChildren = apiResponse?.filter((item) =>
//       [38, 39, 40].includes(item.ManagementMenuID)
//     );
//     // .sort((a, b) => a.MenuName.localeCompare(b.MenuName));

//     const ReportsChildren = apiResponse
//       ?.filter((item) => [33, 32, 27, 4, 35].includes(item.ManagementMenuID))
//       .sort((a, b) => a.MenuName.localeCompare(b.MenuName));

//     const createMenu = (children, id, name, icon, defaultUrl) => ({
//       ManagementMenuID: children.length > 0 ? children[0].ManagementMenuID : id,
//       MenuName: name,
//       IsSubMenu: 0,
//       MenuOrderNo: 1,
//       URLPath: "",
//       CssClassName: icon,
//       MenuActiveStatus: 0,
//       NotificationCount: 0,
//       children,
//     });

//     const userMenu = createMenu(
//       userMenuChildren,
//       15,
//       "User Management",
//       "fa fa-user",
//       ""
//     );
//     const CommunicationMenu = createMenu(
//       CommunicationMenuChildren,
//       9,
//       "Communications",
//       "fa fa-comments",
//       ""
//     );
//     const FacilityMenu = createMenu(
//       FacilityChildren,
//       14,
//       "Facility Management",
//       "fa fa-building",
//       ""
//     );
//     const ReportsMenu = createMenu(
//       ReportsChildren,
//       4,
//       "Reports & Analytics",
//       "fa fa-flag",
//       ""
//     );
//     const ECardMenu = createMenu(
//       ECardChildren,
//       38,
//       "Manage E-Cards",
//       "fa-solid fa-gift",
//       ""
//     );

//     const filteredMenu = apiResponse.filter(
//       (item) =>
//         ![
//           8, 15, 26, 28, 9, 10, 14, 6, 7, 3, 5, 33, 32, 27, 4, 35, 38, 39, 40,
//         ].includes(item.ManagementMenuID)
//     );

//     return [
//       ...filteredMenu,
//       // ...(userMenuChildren.length > 0 ? [userMenu] : []),
//       ...(userMenuChildren.length <= 1 ? userMenuChildren : [userMenu]),

//       // ...(CommunicationMenuChildren.length > 0 ? [CommunicationMenu] : []),
//       ...(CommunicationMenuChildren.length <= 1
//         ? CommunicationMenuChildren
//         : [CommunicationMenu]),

//       // ...(FacilityChildren.length > 0 ? [FacilityMenu] : []),
//       ...(FacilityChildren.length <= 1 ? FacilityChildren : [FacilityMenu]),

//       // ...(ReportsChildren.length > 0 ? [ReportsMenu] : []),
//       ...(ReportsChildren.length <= 1 ? ReportsChildren : [ReportsMenu]),

//       // ...(ECardChildren.length > 0 ? [ECardMenu] : []),
//       ...(ECardChildren.length <= 1 ? ECardChildren : [ECardMenu]),
//     ].sort((a, b) => a.MenuName.localeCompare(b.MenuName));
//   }, [filteredMenus]);

//   useEffect(() => {
//     const list = processMenu();
//     setfiltersidemenu(list);
//     localStorage.setItem("filter_menu_list", JSON.stringify(list));
//   }, [processMenu]);

//   return (
//     <div className="menu inmate-menu-list">
//       {menuList?.map((menu, i) => (
//         <React.Fragment key={i}>
//           {/* {menu?.ManagementMenuID !== 1000 && <NavItem key={i} menu={menu} />} */}
//           {menu?.ManagementMenuID !== 1000 && <Customizesidebar item={menu} />}
//         </React.Fragment>
//       ))}
//     </div>
//   );
// }


export default memo(SidebarNav);
